/**
 * File: qpSummaryPreview.js
 * Project: educore
 * Created Date: 2019-01-23
 * Author: Raziya S
 * Screen : 
 */
class QpSummaryPreviewController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, archiveService, $timeout, CONSTANTS, TPWIZARDCONSTANT) {
        let noActvity = true
        $scope.array = []
        $scope.questionList = []
        $scope.qpStatus = false
        $scope.questionDetails = {};
        $scope.questions = [];
        $scope.score = 0
        this.viewSubmission = true
        $scope.isCreator = false
        $scope.isUserAssigned = false
        $scope.isSubmitApproval = false
        $scope.enableStartNow = false;
        $scope.activityAttended = false
        
        //Boolean - To check whether activity password is present or not
        $scope.isActivityPassword = false

        $scope.total_mark = 0
        let self = this;
        let activityId = $state.params.resourceId
        let authoring = localStorageService.get('authoringData')
        let userId = localStorageService.get("user_id")
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            authService.callAPI(TPWIZARDCONSTANT.API_GET_QP_SUMMARY + activityId, "GET", undefined, function(response) {
                if (response.result != undefined) {
                    loadTemplate(response.result)
                } else {
                    console.log("error : " + response.error)
                    console.log(response.error)
                }
            })
        }
        if (authoring)
            $scope.class = authoring.class
        $scope.isApprover = false
        self.date = '';
        $scope.questionPaper = {};
        let qpSub = undefined;

        let qpId
        this.$onDestroy = () => {
            if (qpSub)
                qpSub.stop()
        }
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "activity"
        })
        console.log("userAccess")
        console.log(userAccess)
        $scope.activityUserPrivilege = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
            })
        }
        let loadTemplate = (resultObj) => {
            let result = undefined
            if (resultObj.data && resultObj.data && resultObj.data.data && resultObj.data.data.template) {
                result = resultObj.data.data.template

                $scope.serverDate = result.server_time
                qpId = result.qp_id
                if (result.teacher_id === userId)
                    $scope.isCreator = true
                //Object - Summary details of the activity
                $scope.qpTemplatePreview = {
                    template: result
                }
                getQPDetails();
                if ($scope.$parent.isViewMode && !$scope.$parent.approveMode && !$scope.isCreator)
                    loadActivityStatus()
                $scope.$apply();
            }
        }


        let getQPDetails = () => {
            authService.callAPI(activityCons.API_QP_DETAILS + qpId, "GET", {}, function(response) {
                if (response.result != undefined) {
                    let result = response.result.data.details
                    $scope.activityId = result.activity_id
                    _.each(result.students, function(eachStud) {
                        if (eachStud._id === userId) {
                            if (eachStud.status === "not attended") {
                                // TO get activity password
                                $scope.enableStartNow = true;
                                if (result.activity_password && result.activity_password !== null && result.activity_password !== undefined && result.activity_password !== "") {
                                    $scope.activityPwd = result.activity_password
                                    $scope.isActivityPassword = true
                                }
                            }
                            $scope.studentStatus = eachStud.status
                            $scope.resultStatus = eachStud.result
                        }
                    })
                    if (result.students && result.students.length > 0)
                        $scope.isUserAssigned = true


                    $scope.isStart = false
                    $scope.isSchedule = false
                    $scope.isReschedule = false
                    $scope.isViewSubmission = false
                    $scope.isPublishResult = false
                    $scope.isPublished = false
                    $scope.isCompleted = false

                    if (result.status == "approved") {
                        $scope.isSchedule = true
                        $scope.isStart = true
                    } else if (result.status == "scheduled") {
                        $scope.isStart = true
                        $scope.isReschedule = true
                    } else if (result.status == "conducted") {
                        $scope.isViewSubmission = true
                        $scope.isPublishResult = true
                        $scope.isCompleted = false
                    } else if (result.status == "published") {
                        $scope.isViewSubmission = true
                        $scope.isCompleted = true
                        $scope.isPublished = true
                    } else if (result.status == "completed") {
                        $scope.isCompleted = true
                        $scope.isViewSubmission = true
                        $scope.isPublishResult = true
                    } else if (result.status == "sent_for_approval") {
                        if (result.current_approver && result.current_approver._id) {
                            if (result.current_approver._id === userId)
                                $scope.isApprover = true
                        }
                    }

                    $scope.questionList = {
                        id: result.activity_id,
                        title: result.question_paper_title,
                        status: result.status,
                        isPractice: result.practice_qn
                    }
                    if (result.teacher_id === userId)
                        $scope.isCreator = true
                    if ($scope.questionList.length === 0) {
                        noActvity = true
                    } else {
                        noActvity = false
                    }
                    $scope.$apply()
                } else {
                    console.log(response.error)
                }
            })
        }
        $scope.routeToQpPreview = function() {
                localStorageService.set("isViewAllQuestion", true);

                $state.go('tpActivityPreview', {
                    "qpId": qpId
                });

            }
            /*
                    $scope.gotoAssigningPage = () => {
                        if ($scope.isUserAssigned) {
                            var confirm = $mdDialog.confirm()
                                .textContent('It will reassign previously assigned students')
                                .ok('Ok')
                                .cancel('Cancel');
                            $mdDialog.show(confirm).then(function() {
                                $state.go('assignStudents', {
                                    qpId: $state.params.qpId,
                                    previousState: {
                                        state: 'qpSummary',
                                        params: $stateParams
                                    }
                                })
                            }, function() {});
                        } else {
                            $state.go('assignStudents', {
                                qpId: $state.params.qpId,
                                previousState: {
                                    state: 'qpSummary',
                                    params: $stateParams
                                }
                            })
                        }
                    }*/

        $scope.checkingChoiceExists = function(choice, data) {
            let isChecked = false;
            if (data.my_answer != undefined) {
                return data.my_answer.indexOf(choice) > -1
            } else {
                return isChecked
            }
        }
        $scope.viewMyAnswer = function(data) {
            if (data.status !== "published" && !data.isPractice) {
                alert = $mdDialog.alert({
                    textContent: 'Result is not published',
                    ok: 'Ok'
                });

                $mdDialog
                    .show(alert)
                    .finally(function() {
                        alert = undefined;
                    });
            } else {
                $state.go('studentAnswerPreview', {
                    qpId: qpId
                })
            }
        }

        function removeSpecialCharacter(value) {
            if (value) {
                value = value.replace(/\\quad/g, "")
                value = value.replace(/\\/g, "")
            }
            return value
        }

        /* Set answered choice is wrong or correct*/
        /*    function setChoice() {
                _.each($scope.questions, function(section) {
                    _.each(section.answers, function(data, key) {
                        $scope.total_mark += parseInt(data.mark)
                        let score = parseFloat(data.my_score)
                        $scope.score += score;
                        if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                            _.each(data.choice, function(choice) {
                                if ($scope.checkingChoiceExists(choice.desc, data)) {
                                    if (!choice.correct) {
                                        choice.wrong = true
                                    }
                                }
                            })
                        } else if (data.type == 'TF') {
                            _.each(data.choice, function(choice) {
                                if (data.my_answer != undefined && choice.tag === data.my_answer[0]) {
                                    if (!choice.correct) {
                                        choice.wrong = true
                                    } else {
                                        choice.correct = true
                                    }
                                }
                            })
                        } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                            let key = 0
                            _.each(data.answer, function(choice) {
                                let correctAnswer = removeSpecialCharacter(choice.desc)
                                if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                    let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        choice.wrong = true
                                    } else {
                                        choice.correct = true
                                    }
                                } else {
                                    choice.wrong = true
                                    if (data.my_answer != undefined) {
                                        data.my_answer[key] = 'Not Answered'
                                    } else {
                                        data.my_answer = []
                                        data.my_answer[key] = 'Not Answered'
                                    }
                                }
                                key++
                            })
                        } else if (data.type == 'OWQ') {
                            let key = 0
                            _.each(data.answer, function(choice) {
                                let correctAnswer = removeSpecialCharacter(choice.desc)
                                if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                    let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        choice.wrong = true
                                    } else {
                                        choice.correct = true
                                    }
                                } else {
                                    choice.wrong = true
                                    if (data.my_answer != undefined) {
                                        data.my_answer[key] = 'Not Answered'
                                    } else {
                                        data.my_answer = []
                                        data.my_answer[key] = 'Not Answered'
                                    }
                                }
                                key++
                            })
                        } else if (data.type == 'MTF') {
                            data.ans_key = []
                            let key = 0
                            _.each(data.option, function(choice) {
                                let correctAnswer = removeSpecialCharacter(choice.question.desc)
                                if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                    let correct = false
                                    let studentAnswer = removeSpecialCharacter(data.my_answer[key].desc)
                                    if (correctAnswer !== studentAnswer) {
                                        correct = false
                                    } else {
                                        correct = true
                                    }
                                    data.ans_key.push({
                                        desc: data.my_answer[key].desc,
                                        correct: correct,
                                        optImage: data.my_answer[key].optImage
                                    })
                                }
                                key++
                            })
                        } else if (data.type == 'ASLLISTEN') {
                            _.each(data.questions, function(aslListQues) {
                                if (aslListQues.type == 'mcq') {
                                    _.each(aslListQues.choice, function(choice) {
                                        if ($scope.checkingChoiceExists(choice.desc, aslListQues)) {
                                            if (!choice.correct) {
                                                choice.wrong = true
                                            }
                                        }
                                    })
                                } else if (aslListQues.type == 'tf') {
                                    _.each(aslListQues.choice, function(choice) {
                                        if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                            if (!choice.correct) {
                                                choice.wrong = true
                                            } else {
                                                choice.correct = true
                                            }
                                        }
                                    })
                                } else if (aslListQues.type == 'fib') {
                                    _.each(aslListQues.answer, function(choice, index) {
                                        let correctAnswer = removeSpecialCharacter(choice.desc)
                                        if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                            let studentAnswer = removeSpecialCharacter(aslListQues.my_answer[index])
                                            if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                                choice.wrong = true
                                            } else {
                                                choice.correct = true
                                            }
                                        } else {
                                            choice.wrong = true
                                            if (aslListQues.my_answer != undefined) {
                                                aslListQues.my_answer[index] = 'Not Answered'
                                            } else {
                                                aslListQues.my_answer = []
                                                aslListQues.my_answer[index] = 'Not Answered'
                                            }
                                        }
                                    })
                                } else if (aslListQues.type == 'text') {
                                    let correctAnswer = removeSpecialCharacter(aslListQues.answer)
                                    if (aslListQues.my_answer != undefined) {
                                        let studentAnswer = removeSpecialCharacter(aslListQues.my_answer)
                                        if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                            aslListQues.wrong = true
                                        } else {
                                            aslListQues.correct = true
                                        }
                                    } else {
                                        aslListQues.wrong = true
                                        aslListQues.my_answer = 'Not Answered'
                                    }
                                }
                            })
                        }

                    })
                })

            }*/

        //$scope.score = $scope.score.toFixed(2)
        /*$scope.cancel = function() {
            $mdDialog.hide();
        };*/
        /*$scope.setFilePath = function(img) {
            let new_url = img ? CONSTANTS.FILE_UPLOAD_URL + img : undefined
            return new_url
        }
        $scope.beautifyFIB = function(question) {
            return question.replace(/_/g, " (_______) ")
        }
*/
        /* Formating the date value to display format*/
        $scope.getDateInFormat = function() {
            var dateFormat = $filter('date')(assignedDate, "dd-MM-yyyy")
            if (dateFormat) {
                self.date = dateFormat;
            } else {
                self.date = "";
            }
        }

        $scope.startTest = function(data) {


            // Object - Holds validation errors
            $scope.errors = {};

            if ($scope.activityPassword === "") {
                $scope.errors['activityPassword'] = "Please enter password";
            } else if ($scope.activityPassword !== $scope.activityPwd) {
                $scope.errors['activityPassword'] = "Please enter correct password";

            } else if ($scope.activityPassword === $scope.activityPwd) {
                $scope.isActivityPassword = false
                $state.go('questionDirective', {
                    qpId: qpId,
                    activityId: activityId
                })
            }
        }

        $scope.scheduleExam = function(dueDate) {
            $scope.qpTemplatePreview.template.date = $scope.dueDate
            let obj = {
                dueDate: $scope.dueDate,
                qpId: qpId,
                userId: userId
            }
            authService.callAPI(activityCons.API_SCHEDULE_EXAM, "POST", obj, function(response) {
                if (response.result) {
                    toastr.success("Activity scheduled Successfully")
                    getQPDetails()
                } else {
                    console.log("error : " + response.error)
                    console.log(response.error)
                }
            })
            $scope.isScheduleDate = false;
            $scope.isSchedule = false
            $scope.isStart = true
            $scope.viewSubmission = false
        }
        $scope.conductTest = function() {

                let reqObj = {
                    activity_id: $scope.activityId,
                    qp_id: qpId
                }
                authService.callAPI(activityCons.API_START_EXAM, "POST", reqObj, function(response) {
                    if (response.result != undefined) {
                        $scope.isScheduleDate = false;
                        $scope.isSchedule = false
                        $scope.isStart = false
                        $scope.isViewSubmission = true
                        $scope.isPublished = false
                        $scope.isPublishResult = false
                        toastr.success("Exam started successfully")
                        getQPDetails()
                    } else {
                        console.log(response.error)
                    }
                })
            }
            /* $scope.filterPerson = () => {
                 let approverList = _.filter($scope.approverRoles, function(person) {
                     return person._id.indexOf($scope.approverRole) !== -1;
                 })
                 if (approverList && approverList.length > 0)
                     $scope.approverRolePersons = approverList[0].users
             }*/

        $scope.gotoPublish = function() {
            authService.callAPI(activityCons.API_PUBLISH_RESULT + qpId + '/' + userId, "GET", {}, function(response) {
                if (response.result != undefined) {
                    toastr.success('Result Published')
                    $scope.isScheduleDate = false;
                    $scope.isSchedule = false
                    $scope.isStart = false
                    $scope.isViewSubmission = true
                    $scope.isPublished = true
                    $scope.isPublishResult = false
                    getQPDetails()
                } else {
                    console.log("error : " + response.error)
                }
            })

        }
        $scope.gotoSubmissionList = function() {

            $state.go("submissionList", {
                qpId: qpId
            })
        }
        $scope.closeDiv = function() {
            $scope.isScheduleDate = false;
        }
        $scope.setScheduleDate = function() {
                if ($scope.isUserAssigned) {
                    $scope.isScheduleDate = true;
                } else {
                    var confirm = $mdDialog.confirm()
                        .textContent('Please assign users')
                        .ok('Ok')
                    $mdDialog.show(confirm).then(function() {
                        $scope.isAssignUsers = true;
                    }, function() {
                        $scope.isAssignUsers = false;
                    });
                    $scope.isPrompt = true
                }
            }
            
        function getTime(millseconds) {
            var oneSecond = 1000;
            var oneMinute = oneSecond * 60;
            var oneHour = oneMinute * 60;
            var oneDay = oneHour * 24;

            var seconds = Math.floor((millseconds % oneMinute) / oneSecond);
            var minutes = Math.floor((millseconds % oneHour) / oneMinute);
            var hours = Math.floor((millseconds % oneDay) / oneHour);
            var days = Math.floor(millseconds / oneDay);

            var timeString = '';
            if (days !== 0) {
                timeString += (days !== 1) ? (days + ' days ') : (days + ' day ');
            }
            if (hours !== 0) {
                timeString += (hours !== 1) ? (hours + ' hours ') : (hours + ' hour ');
            }
            if (minutes !== 0) {
                timeString += (minutes !== 1) ? (minutes + ' min ') : (minutes + ' min ');
            }
            if (seconds !== 0 || millseconds < 1000) {
                timeString += (seconds !== 1) ? (seconds + ' sec ') : (seconds + ' sec ');
            }

            return timeString;
        }

        $scope.stopExam = () => {

            let reqObj = {
                activity_id: $scope.activityId,
                qp_id: qpId
            }

            authService.callAPI(activityCons.API_STOP_EXAM, "POST", reqObj, function(response) {
                if (response.result != undefined) {
                    console.log("result : " + response.result)
                    getQPDetails()
                } else {
                    console.log("error : " + response.error)
                }
            })
        }
        $scope.viewReport = () => {
            $state.go('submissionList', {
                qpId: qpId
            })
        }
        let loadActivityStatus = () => {
            authService.callAPI(activityCons.API_GET_ANSWER_DETAILS + qpId + '/' + userId, "GET", {}, function(response) {
                if (response.result && response.result.data && response.result.data.details) {
                    console.log(response.result.data.details)
                    $scope.activityAttended = true
                } else {
                    console.log("error : " + response.error)
                }
            })
        }
    }
}

export default QpSummaryPreviewController



// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/activity/qpSummaryPreview.js